import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'

type TrackViewCategoryParams = {
  categoryTypeName: string
  categoryName: string
  sortBy: string
  isDirectResult: boolean
}

const useCategoryTracker = () => {
  const tracker = useTracker()

  const trackViewCategoryEvent = ({
    categoryTypeName,
    categoryName,
    sortBy,
    isDirectResult,
  }: TrackViewCategoryParams) => {
    const trackerProperties = {
      category_type_name: categoryTypeName,
      category_name: categoryName,
      sort_by: sortBy,
      is_direct_result: isDirectResult,
    }

    tracker.triggerCustomEvent(FitpetMallEventEnum.ViewCategory, trackerProperties)
  }

  const trackClickCategoryListTabEvent = ({
    categoryTypeName,
    categoryName,
  }: {
    categoryTypeName: string
    categoryName: string
  }) => {
    const trackerProperties = {
      category_type_name: categoryTypeName,
      category_name: categoryName,
    }

    tracker.triggerCustomEvent(FitpetMallEventEnum.ClickCategoryListTab, trackerProperties)
  }

  const trackClickCategoryListItemEvent = ({
    categoryTypeName,
    categoryName,
  }: {
    categoryTypeName: string
    categoryName: string
  }) => {
    const trackerProperties = {
      category_type_name: categoryTypeName,
      category_name: categoryName,
    }

    tracker.triggerCustomEvent(FitpetMallEventEnum.ClickCategoryListItem, trackerProperties)
  }

  const trackViewCategorySimilarProductSection = ({
    originProductId,
    originProductName,
    originSupplyType,
    originBrandId,
    originBrandName,
    categoryName,
    categoryTypeName,
  }: {
    originProductId: number
    originProductName: string
    originSupplyType: string
    originBrandId?: number
    originBrandName: string
    categoryName?: string
    categoryTypeName?: string
  }) => {
    tracker.triggerCustomEvent(FitpetMallEventEnum.ViewCategorySimilarProductSection, {
      list_type: 'similarproduct',
      location: 'category',
      add_location: 'category',
      section_name: '방금 본 상품과 비슷한 상품',
      origin_product_id: originProductId,
      origin_product_name: originProductName,
      origin_supply_type: originSupplyType,
      origin_brand_id: originBrandId,
      origin_brand_name: originBrandName,
      category_type_name: categoryTypeName,
      category_name: categoryName,
    })
  }

  return {
    trackViewCategoryEvent,
    trackClickCategoryListTabEvent,
    trackClickCategoryListItemEvent,
    trackViewCategorySimilarProductSection,
  }
}

export { useCategoryTracker }
